const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

const isFiniteNumber = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value);

const toValidDate = (value: unknown): Date | undefined => {
  if (!isFiniteNumber(value) && typeof value !== 'string') {
    return undefined;
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? undefined : date;
};

export const parseBookedMeeting = (data: unknown): Date | undefined => {
  if (!isRecord(data) || !isRecord(data.meetingsPayload) || !isRecord(data.meetingsPayload.bookingResponse)) {
    return undefined;
  }

  const { bookingResponse } = data.meetingsPayload;
  const postResponse = isRecord(bookingResponse.postResponse) ? bookingResponse.postResponse : undefined;
  const timerange = postResponse && isRecord(postResponse.timerange) ? postResponse.timerange : undefined;
  const event = isRecord(bookingResponse.event) ? bookingResponse.event : undefined;

  return toValidDate(timerange?.start) ?? toValidDate(event?.dateTime);
};
